import React, { Component } from "react";
import { Link } from "redux-little-router";
import { Comment as SemanticUIComment } from "semantic-ui-react";
import { Icon, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import "./index.css";
import { deleteComment, editComment, enterEditMode } from "../../../../../../../../actions/commentActions";
import { showConfirmDialog, hideConfirmDialog } from "../../../../../../../../actions";
import { COMMENT_STATUS } from "./constants";
import { selectUserId } from "../../../../../../../../util/selectors";
import { constructUserProfilePath } from "../../../../../../../../util/index";
import CommentInputEdit from "../../../CommentInput/CommentInputEdit";
import ProfilePicture from "../../../../../../../ProfilePicture";

class Comment extends Component {
  constructor(props) {
    super(props);
    const { comment: { _id: commentId, postId } } = this.props;
    this.deleteComment = this.deleteComment.bind(this);
    this.shouldDisplayDropdown = this.shouldDisplayDropdown.bind(this);
    this.options = [
      { key: `edit`, text: "Edit", onClick: () => props.enterEditMode({ postId, commentId, isEditMode: true }) },
      { key: `delete`, text: "Delete", onClick: this.deleteComment },
    ];
  }
  deleteComment() {
    const { comment: { _id: commentId, postId } } = this.props;

    this.props.showConfirmDialog({
      onConfirm: () => this.props.deleteComment({ postId, commentId }),
      onCancel: this.props.hideConfirmDialog,
      content: "Are you sure you want to delete this comment?",
      confirmText: "DELETE",
      confirmColor: "red",
    });
  }

  shouldDisplayDropdown(comment) {
    const isCommentPosted = comment.status !== COMMENT_STATUS.PENDING && comment.status !== COMMENT_STATUS.FAILURE;
    const userIsOwner = comment.owner.id === this.props.loggedInUserId;
    return isCommentPosted && userIsOwner;
  }

  render() {
    const { animationClass, comment, comment: { owner, isInEditMode } } = this.props;
    const profilePath = constructUserProfilePath(owner);

    return (
      <SemanticUIComment.Group minimal className={`single-comment ${animationClass}`}>
        {isInEditMode ? (
          <CommentInputEdit commentText={comment.content} commentId={comment._id} />
        ) : (
          <SemanticUIComment>
            <Link href={profilePath} className="-avatar-link">
              <div className="avatar">
                <ProfilePicture userId={owner.id} size="s" fallbackUrl={owner.picture} />
              </div>
            </Link>
            <SemanticUIComment.Content>
              <SemanticUIComment.Author>
                <Link className="author" href={profilePath}>
                  {owner.name}
                </Link>
              </SemanticUIComment.Author>
              <SemanticUIComment.Metadata className="-comment-date">
                <div>{comment.createdAt}</div>
              </SemanticUIComment.Metadata>
              <SemanticUIComment.Text>{comment.content}</SemanticUIComment.Text>
              <SemanticUIComment.Actions>
                {this.shouldDisplayDropdown(comment) ? (
                  <Dropdown
                    trigger={<Icon name="ellipsis horizontal" size="large" color="grey" className="-ellipsis-nav" />}
                    options={this.options}
                    pointing="top right"
                    icon={null}
                  />
                ) : null}
              </SemanticUIComment.Actions>
            </SemanticUIComment.Content>
          </SemanticUIComment>
        )}
      </SemanticUIComment.Group>
    );
  }
}

const mapStateToProps = state => ({
  loggedInUserId: selectUserId(state),
});

const mapDispatchToProps = dispatch => ({
  enterEditMode: ({ isEditMode, commentId, postId }) => dispatch(enterEditMode({ isEditMode, commentId, postId })),
  editComment: ({ postId, commentId }) => dispatch(editComment({ postId, commentId })),
  deleteComment: ({ postId, commentId }) => dispatch(deleteComment({ postId, commentId })),
  showConfirmDialog: (...props) => dispatch(showConfirmDialog(...props)),
  hideConfirmDialog: (...props) => dispatch(hideConfirmDialog(...props)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Comment);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/CommentsList/components/Comment/index.js